export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7522.5b570580.jpg";